<template>
  <div class="mt-3">
    <h2>{{$t('events.document')}}</h2>
    <div>
      <div v-if="loading">
        <PolygonLoader
          :centered="false"
          :size="40"
          :width="3"
        />
      </div>
      <div v-else>
        <PolygonEmptySearchResult
          v-if="noItemsFound"
          :noResultText="$t('events.noFilesFound')"
          hideIcon="true"
        />
        <ul
          class="files"
          v-else
        >
          <li
            v-for="(file, i) in items"
            :key="i"
            class="file"
          >
            <a
              class="file__link"
              :href="getDownloadUrl(file)"
            >
              <div class="file__type">
                <span :class="'icon-' + getIcon(file)"></span>
              </div>
              <div class="file__details">
                {{ file.description }}
                <div class="file__date">{{ file.date }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="d-flex align-center flex-wrap">
      <div class="mt-3 file-input-cnt" v-if="isCorrectBackendSystem && hasEnabledFileUpload">
        <v-file-input
          :label="$t('documents.uploadFilePlaceholder')"
          multiple
          accept=".pdf, image/*, .doc, .docx, .xml, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ref="files"
          v-model="files"
          :errorMessages="errorMessages"
          @change="handleChange"
          ></v-file-input>
      </div>
        <transition name="fade">
          <v-btn v-if="files.length > 0" text dense color="primary"  class="ml-sm-3" @click="submitFiles">{{ $t('documents.uploadFiles') }}</v-btn>
        </transition>
    </div>
    <p class="text--disabled text-caption font-italic pt-2">{{ $t('documents.fileUploadInfo') }}</p>
  </div>

</template>

<script>
import repository from '@/core/repository/entity-repository'
import entityList from '@/mixins/entity-list'
import httpService from '@/core/http-service'
import constants from '@/core/constants'
import _ from 'lodash'

export default {
  mixins: [entityList],
  data() {
    return{
      files: [],
      errorMessages: null
    }
  },
  activated() {
    this.loadEvents()
  },
  computed: {
    isCorrectBackendSystem() {
      return this.currentErrand.backend_system === constants.backendSystem.apps10
    },
    hasEnabledFileUpload() {
      return this.hasFeature('useFileUploader')
    }
  },
  methods: {
    loadEvents() {
      this.loading = true
      this.items = []
      return repository.getAttachments(this.errandId).done(attachments => {
        _.forEach(attachments, attachment => {
          this.items.push(attachment)
        })
        this.loading = false
      })
    },
    getDownloadUrl(attachment) {
      return `${httpService.baseUrl}/api/v1/attachments/${
        attachment.id
      }?${httpService.getDefaultQueryParams({
        token: this.$store.getters.authenticationData.accessToken
      })}`
    },
    getIcon(file) {
      const extension = file.name.split('.').pop()
      switch (extension) {
        case 'jpg':
        case 'jpeg':
          return 'img'
        case 'bmp':
        case 'png':
        case 'tif':
        case 'gif':
          return 'img'
        case 'pdf':
          return 'pdf'
        case 'doc':
          return 'doc'
        default:
          return 'misc'
      }
    },
    handleChange() {
      this.errorMessages = null
    },
    submitFiles() {
      repository.postNewAttachments(this.errandId, this.files).then(() => {
        this.files = []
        this.loadEvents()
      }).catch(error => {
        this.errorMessages = _.get(error, 'responseJSON.exceptionMessage', this.$t('documents.fileUploadErrorMessage'))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.files {
  @include layout-box;
  @include layout-list;
  @include font-size(s);
}

.file {
  position: relative;
}

.file__type {
  position: relative;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: $border-radius-box;
  background-color: color(primary, 0.05);

  span {
    display: block;
    position: absolute;
    width: auto;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    font-size: 1.875em;
    color: color(primary);
  }

  // > * {
  //   wisdth: 100%;
  //   heisght: 100%;
  // }

  // img {
  //   bsorder-radius: $border-radius-box;
  // }
}

.file__details {
  flex-grow: 1;
  margin-left: measure(s);
  margin-right: measure(s);
}

.file__date {
  @include font-size(xs);
  color: color(medium);
}

.file:last-child .file__link:after {
  display: none;
}

.file__link {
  display: flex;
  align-items: center;
  padding: measure(s);
  transition: all 300ms;

  color: color(black);
  text-decoration: none;

  &:after {
    content: "";
    display: block;
    width: calc(100% - #{measure(s)});
    height: 0.0625rem;
    position: absolute;
    bottom: 0;
    left: measure(s);
    background-color: color(subtle);
    transition: all 300ms;
  }

  .no-touch &:hover {
    background-color: color(black, 0.03);
    &:after {
      background-color: transparent;
    }
  }
}

.float {
  float: right;
}

.file-input-cnt{
  width: 15rem;
}

.fade-enter-active {
  animation: fade 0.4s ease;
}
.fade-leave-active {
  animation: fade 0.4s ease reverse;
}
</style>
